import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
    children: ReactNode;
    fallback?: ReactNode;
}

interface State {
    hasError: boolean;
    error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('[ErrorBoundary] Uncaught error:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            if (this.props.fallback) return this.props.fallback;

            return (
                <div style={{
                    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                    height: '100vh', background: '#0F0F12', color: '#F4F4F5', fontFamily: "'Inter', sans-serif",
                    textAlign: 'center', padding: '2rem',
                }}>
                    <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>⚠️</div>
                    <h1 style={{ fontSize: '1.5rem', marginBottom: '0.5rem', color: '#EF4444' }}>
                        Something went wrong
                    </h1>
                    <p style={{ fontSize: '0.95rem', color: '#71717A', maxWidth: '400px', marginBottom: '1.5rem' }}>
                        An unexpected error occurred. Please try refreshing the page.
                    </p>
                    <p style={{ fontSize: '0.8rem', color: '#52525B', fontFamily: 'monospace', marginBottom: '1.5rem' }}>
                        {this.state.error?.message}
                    </p>
                    <button
                        onClick={() => window.location.reload()}
                        style={{
                            padding: '0.6rem 1.5rem', background: '#6366F1', color: '#fff',
                            border: 'none', borderRadius: '8px', fontSize: '0.9rem', cursor: 'pointer',
                        }}
                    >
                        Refresh Page
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
